import { useState } from 'react';
import { UntactTvBanner, useUntactTvBannersQuery } from '@api/GoodocAPI';
import { graphQLClient } from '@api/client';
import { useNavigate } from 'react-router-dom';
import { ADVERTISEMENT } from '@router/path';

const useBanner = () => {
  const navigate = useNavigate();
  const [currentBanner, setCurrentBanner] = useState<UntactTvBanner | undefined>();

  const { data: banners } = useUntactTvBannersQuery(graphQLClient);

  const navigateAdvertisePage = () => {
    if (!currentBanner) return;

    navigate(ADVERTISEMENT, { state: { image: currentBanner.detailImage } });
  };

  const showAdvertisement = (advertisement: UntactTvBanner) => {
    setCurrentBanner(advertisement);
  };

  const hideAdvertisement = () => {
    setCurrentBanner(undefined);
  };

  return {
    currentBanner,
    banners: banners?.untactTvBanners || [],
    navigateAdvertisePage,
    showAdvertisement,
    hideAdvertisement
  };
};

export default useBanner;
